import React from 'react';
import { Button } from './ui/button';
import { Phone, MapPin, ShoppingBag } from 'lucide-react';

const Hero = () => {
  const scrollToMenu = () => {
    document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCall = () => {
    window.location.href = 'tel:02078333399';
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Static Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1554306297-0c86e837d24b?w=1920&q=85)',
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      
      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center px-6 text-center">
        <div className="max-w-4xl space-y-6 animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
            London's Best Value Grill
            <span className="block text-orange-500 mt-2">in the Heart of N1</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 font-medium">
            Big portions. Fresh grill. Unbeatable prices.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <Button 
              size="lg" 
              className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-orange-500/50 transition-all duration-300 hover:scale-105"
              onClick={handleCall}
            >
              <Phone className="mr-2 h-5 w-5" />
              Call Now
            </Button>
            
            <Button 
              size="lg" 
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-black px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
              onClick={scrollToMenu}
            >
              <ShoppingBag className="mr-2 h-5 w-5" />
              View Menu
            </Button>
            
            <Button 
              size="lg" 
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
              onClick={() => window.open('https://www.google.com/maps/place/6+Chapel+Market,+London+N1+9EZ', '_blank')}
            >
              <MapPin className="mr-2 h-5 w-5" />
              Get Directions
            </Button>
          </div>
          
          {/* Location Tag */}
          <div className="pt-8 flex items-center justify-center gap-2 text-gray-300">
            <MapPin className="h-4 w-4" />
            <span className="text-sm">6 Chapel Market, London N1 9EZ</span>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white/50 rounded-full animate-scroll" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
